<template>
    <div>
      <br />
        <v-row v-bind:class="marginesy">
          <v-col cols="12" md="8">
            <p class="text-h6">Koszyk</p>
              <v-card
                v-for="(item, i) in getProdInCart"
                :key="i"
                variant="outlined"
                class="pa-3 ma-2"
              > 
                <p class="text-body-2"> {{ item.prod_name }} </p>
                <p class="text-caption"> {{ item.size }}cm, {{ item.thickness }} ({{ item.weight }}g) - {{ item.price }}zł (liczba sztuk: {{ item.quantity }}) </p>
              </v-card>
              <v-card
                class="pa-3 ma-2"
                color="secondary"
                v-if="promocodepresent"
              > 
                <p class="text-body-2 text-white"> Kupon rabatowy <b> -{{ promocodediscount }}% ({{ promocodediscountprice }} zł taniej) </b> </p>
              </v-card>
              <p class="text-h6 text-primary">
                  {{ cartsum }}zł
              </p> <br />
              <v-row justify='center'><v-btn variant="outlined" @click="$router.push('/koszyk')">Powrót do koszyka</v-btn></v-row>
          </v-col>

          <v-col cols="12" md="4">
            <p class="text-h6">Dane do wysyłki</p>
            <v-card
              v-for="(user, i) in getUserData"
              :key="i"
              variant="outlined"
              class="pa-3 ma-2"
            >  
              <p class="text-body-1"> {{ user.name }} {{ user.surname }} 
                <br />
                {{ user.email }} <br />
                {{ user.phonenum }} <br /> <br />
                {{ user.address }} {{ user.address1 }} / {{ user.address2 }} <br />
                {{ user.city }} {{ user.zipcode }} ({{ user.voivodeship }})<br />
                Sposób dostawy: {{ user.deliveryoption }}<br />
                <b>DARMOWA DOSTAWA!</b>
              </p> 
            </v-card> <br />
            <p class="text-h6">Dane do faktury</p>
            <v-card
              variant="outlined"
              v-if="this.getUserData[0].FVcheckbox === true"
            >  
              <p class="text-body-1"> Takie same jak wysyłkowe </p> 
            </v-card>
            <div v-if="this.getUserData[0].FVcheckbox !== true">
            <v-card
              v-for="(user, i) in getUserData"
              :key="i"
              variant="outlined"
              class="pa-3 ma-2"
            >  
              <p class="text-body-1"> {{ user.FVfirm }} {{ user.FVnip }} <br /> {{ user.FVname }} {{ user.FVsurname }} 
                <br />
                {{ user.FVaddress }} {{ user.FVaddress1 }} / {{ user.FVaddress2 }} <br />
                {{ user.FVcity }} {{ user.FVzipcode }} ({{ user.FVvoivodeshipval }})<br />
              </p> 
            </v-card></div><br />
            <v-row justify='center'><v-btn variant="outlined" @click="$router.push('/koszyk-dane')">Zmień dane do wysyłki</v-btn></v-row>
          </v-col>
        </v-row>
        <v-row class="ma-16" align="center">
          <v-col cols="12" md="3"> 
            <v-text-field
              v-model="promocode"
              label="Kod rabatowy"
              variant="outlined"
              density="comfortable"
              append-icon="mdi-check"
              @click:append="check_promo_code(this.promocode)"
              :disabled="codedis"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-16" align="center">
          <v-col cols="12" md="3">
            <p class=text-subtitle-1> Sposób płatności </p> 
            <v-radio-group v-model="paymentoption" inline>
              <v-radio label="Przelew tradycyjny" value="Przelew Tradycyjny"></v-radio>
              <v-radio label="Przelewy24" value="Przelewy24"></v-radio>
            </v-radio-group>
            <v-row class="mt-2 align-center justify-start text-start">                
                Możliwość zakupu ratalnego z <v-img height="30" max-width="100" src='../assets/Shop/Przelewy24_logo.png'></v-img>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="mx-16" justify="center">
          <v-col cols="12">
            <v-row justify="center">
              <v-checkbox v-model="checkbox_agreement" label="Zgadzam się z regulaminem oraz polityką prywatności sklepu Alpakowy Raj - kołdry"></v-checkbox>
            </v-row>
            <v-row justify="center">
              <v-btn :disabled="!checkbox_agreement" color="primary" :loading="loading" @click="order()">Zamawiam i płacę</v-btn>
            </v-row>
            <br />
          </v-col>
        </v-row>
        
        <v-snackbar
        v-model="msgSnackbar"
        color="secondary"
        >
        Podany kupon jest nieprawidłowy
        <template v-slot:actions>
            <v-btn
            icon="mdi-close"
            color="red"
            @click="msgSnackbar = false"
            >            
            </v-btn>
        </template>
        </v-snackbar>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import axios from 'axios'
  import moment from 'moment';
  import { remCookie } from '@/store/cookies';

  export default {
    data () {
      return {
        marginesy: '',
        promocode: '',
        checkbox_agreement: false,
        cartsum: 0,
        promocodepresent: false,
        promocodediscount: 0,
        promocodediscountprice: 0,
        order_num: '',
        msgSnackbar: false,
        codedis: false,
        paymentoption: 'Przelew Tradycyjny',
        loading: false,
      }
    },
    computed: {
      ...mapGetters([
        'getUserData',
        'getProdInCart',
      ]),
    },
    created() {
      if(this.getProdInCart.length < 1){
        this.$router.push('/koszyk')
      }
      if(this.$vuetify.display.mobile == false){
        this.marginesy = "ma-16"
      }
    },
    mounted() {
      this.size = this.$store.getters.getDuvetsSizes;
      this.thickness = this.$store.getters.getDuvetsThickness;
      this.price_sum();
    },
    methods: {
      ...mapActions([
        'storeOrderNumber',
        'clearUserCart'
      ]),
      price_sum() {
          this.cartsum = this.getProdInCart.reduce((current, next) =>
              current + next.price, 0);
      },
      check_promo_code(code) {
        if (code !== '') {
          axios
          .get(`${process.env.VUE_APP_API}/check_coupon`, {params: {'name': code}})
          .then((resp) => {
            //console.log(resp);
            if (resp.data.length > 0){
              this.promocodediscount = resp.data[0].percentage;
              this.promocodediscountprice = (this.cartsum/100)*this.promocodediscount;
              this.promocodepresent = true;
              this.cartsum = this.cartsum - this.promocodediscountprice
              this.codedis = true
            } else {
              this.msgSnackbar = true;
            }
          });
        } 
      },
      gen_num_order() {
        const date = moment().format("YYMMDD")
        var hour = moment().format("HHmm")
        var rannum = Math.floor(Math.random()*9999)
        this.order_num = String(date)+String(hour)+String(rannum)

      },
      order() {
        this.loading = true
        var mail = this.getUserData[0].email
        this.gen_num_order();
        var order = {'num': this.order_num}
        this.storeOrderNumber(order);
        var products = '';
        for(let i = 0; i < this.getProdInCart.length; i++) { 
          var tempprod = String(this.getProdInCart[i].quantity)+'x '+String(this.getProdInCart[i].prod_name)+' '+String(this.getProdInCart[i].thickness)+' - '+String(this.getProdInCart[i].size);
          products = products.concat(', ', tempprod);
        }

        var date = moment().format("YYYY-MM-DD");
        var buyername = String(this.getUserData[0].name)+' '+String(this.getUserData[0].surname);
        var contact = String(this.getUserData[0].phonenum)+' / '+String(this.getUserData[0].email);
        var address = String(this.getUserData[0].address)+' '+String(this.getUserData[0].address1)+'/'+String(this.getUserData[0].address2);

        var FVfirminfo = String(this.getUserData[0].FVfirm)+' '+String(this.getUserData[0].FVnip);
        var FVbuyername = String(this.getUserData[0].FVname)+' '+String(this.getUserData[0].FVsurname);
        var FVaddress = String(this.getUserData[0].FVaddress)+' '+String(this.getUserData[0].FVaddress1)+'/'+String(this.getUserData[0].FVaddress2);

        var coupon = '';
        if(this.promocode !== '') {
          coupon = this.promocode;
        } else {
          coupon = 'Nie';
        }
        axios
        .post(`${process.env.VUE_APP_API}/new_order`, {
          'ordernum': this.order_num, 
          'date': date, 
          'products': products, 
          'price': this.cartsum, 
          'coupon': coupon, 
          'buyername': buyername, 
          'contact': contact, 
          'add': address, 
          'city': this.getUserData[0].city, 
          'voivo': this.getUserData[0].voivodeship, 
          'zip': this.getUserData[0].zipcode,

          'FVCheck': this.getUserData[0].FVcheckbox,
          'FVfirm': FVfirminfo,
          'FVbuyername': FVbuyername, 
          'FVadd': FVaddress, 
          'FVcity': this.getUserData[0].FVcity, 
          'FVvoivo': this.getUserData[0].FVvoivodeshipval, 
          'FVzip': this.getUserData[0].FVzipcode, 

          'delivery': this.getUserData[0].deliveryoption,
          'payment': this.paymentoption 
        }, {
            headers: { 'Content-Type': 'application/json' }
        })

        if(this.paymentoption === 'Przelew Tradycyjny') {
          var ordern = this.order_num
          var money = this.cartsum
          //mail do klienta
          axios
          .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': mail, 
            'subject': '[Alpakowy Raj - Kołdry] Nowe Zamówienie!', 
            'text': '<h4>Drogi kliencie,<br />serdecznie dziękujemy za zakupy w Alpakowym Raju! <br /></h4>Zamówienie nr '+ordern+'<br />Zamówione przez ciebie produkt(y): '+products+'<br />Całkowita kwota zamówienia: '+money+' złotych<br /><br /><h3 style="margin-bottom: 0px"> Przelewy prosimy dokonywać na nr konta: <br /> <b> 84 1050 1520 1000 0090 6749 4519 </b> <br />o tytule <b> "Zamówienie nr '+ordern+'"</b> </h3>Alpakowy Raj Paweł Milde<br />ul. Obornicka 250/2 60-693 Poznań <br /> <br /><br />W kolejnych wiadomościach mailowych będziemy informować o dalszym procesie realizacji zamówienia.<br /> <br />Jeśli uważasz, że doszło do pomyłki, bądź chcesz zrezygnować z zamówienia, uprzejmie prosimy o wiadomość na kontakt@alpakowyraj.pl<br /> <br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie, prosimy na nią nie odpowiadać ---</i>', 
          }, {
              headers: { 'Content-Type': 'application/json' }
          })

          //mail do Pablito
          axios
          .post(`${process.env.VUE_APP_API}/mail-client`, {
            'to': 'pawelmilde@gmail.com', 
            'subject': '[Alpakowy Raj - Kołdry] Nowe Zamówienie!', 
            'text': '<center><h4>Nowe zamówienie!<br />o numerze '+ordern+'! <br /></h4>Zamówione produkt(y): '+products+'<br />Całkowita kwota zamówienia: '+money+' złotych<br /><br /><br />Więcej szczegółów w Panelu Administratora.<br /> <br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie ---</i> </center>', 
          }, {
              headers: { 'Content-Type': 'application/json' }
          });
          this.clearUserCart()
          remCookie()

          this.$router.push('/thankyou')

        }else if(this.paymentoption === 'Przelewy24') {
          var grosze = this.cartsum*100
          var ordern2 = this.order_num
          var money2 = this.cartsum
          grosze = parseInt(grosze)
          axios
          .post(`${process.env.VUE_APP_API}/P24_register`, {
            'ordernum': this.order_num,
            'clientmail': this.getUserData[0].email, 
            'price': grosze, 
          }, {
              headers: { 'Content-Type': 'application/json' }
          })
          .then(function(response) {              
            //mail do klienta
            axios
            .post(`${process.env.VUE_APP_API}/mail-client`, {
              'to': mail, 
              'subject': '[Alpakowy Raj - Kołdry] Nowe Zamówienie!', 
              'text': '<h4>Drogi kliencie,<br />serdecznie dziękujemy za zakupy w Alpakowym Raju! <br /></h4>Zamówienie nr '+ordern2+'<br />Zamówione przez ciebie produkt(y): '+products+'<br />Całkowita kwota zamówienia: '+money2+' złotych<br /><br /><h3 style="margin-bottom: 0px"> Płatności prosimy dokonać poprzez wybranego w zamówieniu operatora</h3><br /> <br /><br />W kolejnych wiadomościach mailowych będziemy informować o dalszym procesie realizacji zamówienia.<br /> <br />Jeśli uważasz, że doszło do pomyłki, bądź chcesz zrezygnować z zamówienia, uprzejmie prosimy o wiadomość na kontakt@alpakowyraj.pl<br /> <br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie, prosimy na nią nie odpowiadać ---</i>', 
            }, {
                headers: { 'Content-Type': 'application/json' }
            })

            //mail do Pablito
            axios
            .post(`${process.env.VUE_APP_API}/mail-client`, {
              'to': 'pawelmilde@gmail.com', 
              'subject': '[Alpakowy Raj - Kołdry] Nowe Zamówienie!', 
              'text': '<center><h4>Nowe zamówienie!<br />o numerze '+ordern2+'! <br /></h4>Zamówione produkt(y): '+products+'<br />Całkowita kwota zamówienia: '+money2+' złotych<br /><br /><br />Więcej szczegółów w Panelu Administratora.<br /> <br />Pozdrawiamy! <br />Zespół Alpakowy Raj - Kołdry <br /><br /><i>--- Wiadomość generowana automatycznie ---</i> </center>', 
            }, {
                headers: { 'Content-Type': 'application/json' }
            })
            window.location.href = "https://secure.przelewy24.pl/trnRequest/"+String(response.data);
            
            this.clearUserCart()
            remCookie();
          });
        }
      }
    }
  } 
</script>